/**
 * Created by maofaming on 2017/4/21.
 */

class Store {
  _store = {};
  _isNativeStore = false;

  constructor() {
      if (!window.localStorage) {
          this._isNativeStore = false
          console.log('window.localStorage不可用，已转为内存存储！')
      } else {
          this._isNativeStore = true
          this._store = window.localStorage
      }
  }

  setItem(key, value) {
      if (this._isNativeStore) {
          this._store.setItem(key, value)
      } else {
          this._store[key] = value
      }
  }

  getItem(key) {
      if (this._isNativeStore) {
          return this._store.getItem(key)
      } else {
          return this._store[key]
      }
  }
}

class Debugger {
  _requestStore = [];
  _store = null;
  _maxCount = 300;

  constructor() {
      this._store = new Store()
      this._requestStore = this.getRecord()
  }

  static getParameter() {
      return {
          userAgent: navigator.userAgent,
          cookie: document.cookie,
          referrer: location.href,
          origin: document.origin
      }
  }

  download(name) {
      let { cookie, userAgent } = Debugger.getParameter()
      let fileName = name + '_debug.json'
      let content = JSON.stringify(
          {
              cookie: cookie,
              userAgent: userAgent,
              curl: this.getRecord()
          },
          null,
          4
      )
      let blob = new Blob([content])
      let aLink = document.createElement('a')
      let url = URL.createObjectURL(blob)

      aLink.download = fileName
      aLink.href = url
      aLink.click()
      window.URL.revokeObjectURL(url)
  }

  getRecord() {
      let requestStroage = this._store.getItem('requestStorage')
      if (requestStroage) {
          try {
              return JSON.parse(requestStroage)
          } catch (err) {
              console.log('本地调试数据恢复错误...')
              this._store.setItem('requestStorage', '')
              return []
          }
      } else {
          return []
      }
  }

  updateRecord() {
      try {
          this._store.setItem(
              'requestStorage',
              JSON.stringify(this._requestStore, null, 2)
          )
      } catch (err) {
          console.log('本地调试数据恢复错误...')
          this._store.setItem('requestStorage', '')
          return []
      }
  }

  save(url, type, data) {
      let myDate = new Date()
      let curl = Debugger.createCURL(url, type, data)
      let requestStore = this._requestStore
      let length = requestStore.length
      if (length > this._maxCount) {
          requestStore.shift()
      }
      requestStore.push({
          time: myDate.toLocaleString(),
          curl
      })
      this.updateRecord()
  }

  static createCURL(url, type, data) {
      let { referrer, origin } = Debugger.getParameter()
      return [
          'curl',
          "'" + url + (type === 'post' ? '' : '?' + data) + "'",
          "-H 'Pragma: no-cache'",
          "-H 'Origin: " + origin + "'",
          "-H 'Accept-Encoding: gzip, deflate, sdch'",
          "-H 'Accept-Language: zh-CN,zh;q=0.8,en;q=0.6,zh-TW;q=0.4'",
          "-H 'User-Agent: " + navigator.userAgent + "'",
          type === 'post'
              ? "-H 'Content-Type: application/x-www-form-urlencoded; charset=UTF-8' "
              : '',
          "-H 'Accept: application/json, text/plain, */*'",
          "-H 'Referer: " + referrer + "'",
          "-H 'Connection: keep-alive'",
          "-H 'Cache-Control: no-cache'",
          type === 'post' ? "--data '" + data + "'" : '',
          '--compressed'
      ].join(' ')
  }
}

export default new Debugger()



// WEBPACK FOOTER //
// ./src/common/js/Debugger.js